SortingGridPreprocessorFactory.$inject = [
	'mx.SolutionBuilderAgent.PersonalizationService',
	'mx.SolutionBuilderAgent.mxColumnDefinitionService',
	'$q',
	'mx.sb.Agent.DataQuery.SortingPreprocessor',
	'mx.SolutionBuilderAgent.BasePreprocessor',
];

export default function SortingGridPreprocessorFactory(personalizationService, columnDefinition, $q, newSortingPreprocessorFactory, BasePreprocessor) {
	class SortingGridPreprocessor extends BasePreprocessor {
		constructor() {
			super();
			this.type = mx.SolutionBuilderAgent.PreprocessorType.Sorting;
			this.preprocessor = newSortingPreprocessorFactory();

			Object.defineProperties(this, {
				sortedColumns: {
					enumerable: true,
					get: function () {
						return this.preprocessor.sortedColumns;
					},
				},
				columns: {
					enumerable: true,
					get: function () {
						return this.preprocessor.columns;
					},
				},
				sortableColumns: {
					enumerable: true,
					get: function () {
						return this.preprocessor.sortableColumns;
					},
				},
			});

			return this;
		}

		build() {
			return this.executor.sortingBuild(this.sortedColumns);
		}

		load(widgetId) {
			this.preprocessor.init({
				columns: this.dataQueryList.columns,
			});

			this.preprocessor.addChangedHandler(() => {
				this.callChanged();
			});

			return this._initPersonalization(widgetId, this.dataQueryList.columns);
		}

		setSort(sortConfig) {
			this.preprocessor.setSort(sortConfig);
		}

		_initPersonalization(widgetId, columns) {
			const self = this;

			return personalizationService.getGridPersonalization(widgetId).then((personalization) => {
				columns.forEach((column) => {
					if (personalization[column.Name]) {
						angular.extend(column, personalization[column.Name]);
					}
				});
				// Reorder columns
				columns.sort((a, b) => {
					const aName = personalization[a.Name];
					const bName = personalization[b.Name];
					const bothPersonalized = aName && aName.__personalizedPosition && bName && bName.__personalizedPosition;

					return bothPersonalized ? aName.__personalizedPosition - bName.__personalizedPosition : (a.Position || 0) - (b.Position || 0);
				});

				return self.preprocessor.initPersonalization(widgetId);
			});
		}
	}

	return SortingGridPreprocessor;
}
